import { LinkAnother } from '@/fsd/shared/ui/icons';

export const FAQ_LINKS = [
  { to: '/faq/categories', label: 'Категории' },
  { to: '/faq/videos', label: 'Видео' },
  { to: '/faq/webinars', label: 'Вебинары' },
  { to: '/faq/req', label: 'Обратная связь' },
  {
    to: '/',
    label: 'Перейти в сервис',
    icon: <LinkAnother />,
    external: true,
  },
];
